import { render, staticRenderFns } from "./SettingBase.vue?vue&type=template&id=27625252&scoped=true"
import script from "./SettingBase.vue?vue&type=script&lang=js"
export * from "./SettingBase.vue?vue&type=script&lang=js"
import style0 from "./SettingBase.vue?vue&type=style&index=0&id=27625252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27625252",
  null
  
)

export default component.exports